import { numarray, stringToObject } from '../../utils/string';
import { currencyFractionsRaw, currencyRegionsRaw } from './autogen.currencies';
var currencyFractions = (function () {
    var map = {};
    currencyFractionsRaw.split('|').forEach(function (r) {
        var parts = r.split(':');
        var code = parts[0];
        var values = numarray(parts[1]);
        map[code] = {
            digits: values[0],
            rounding: values[1],
            cashDigits: values[2],
            cashRounding: values[3],
        };
    });
    return map;
})();
var defaultCurrencyFractions = {
    digits: 2,
    rounding: 0,
    cashDigits: 2,
    cashRounding: 0,
};
var currencyRegions = stringToObject(currencyRegionsRaw, '|', ':');
/**
 * @public
 */
export var getCurrencyFractions = function (code) {
    return currencyFractions[code] || defaultCurrencyFractions;
};
/**
 * @public
 */
export var getCurrencyForRegion = function (region) {
    return (region !== 'ZZ' && currencyRegions[region]) || 'USD';
};
//# sourceMappingURL=util.js.map